import React, { useState } from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";

const GenericEventDates = ({ selectedEvent, ids, component, handleEvents, savedIds = [], isWholesalerEvent }) => {
  const [showModal, setShowModal] = useState(false);
  const [viewMoreindex, setViewMoreIndex] = useState();

  const handleClose = () => setShowModal(false);

  const Calendar = (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
      <path fill="currentColor" d="M7.288 13.713Q7 13.425 7 13t.288-.712T8 12t.713.288T9 13t-.288.713T8 14t-.712-.288m4 0Q11 13.426 11 13t.288-.712T12 12t.713.288T13 13t-.288.713T12 14t-.712-.288m4 0Q15 13.426 15 13t.288-.712T16 12t.713.288T17 13t-.288.713T16 14t-.712-.288M5 22q-.825 0-1.412-.587T3 20V6q0-.825.588-1.412T5 4h1V2h2v2h8V2h2v2h1q.825 0 1.413.588T21 6v14q0 .825-.587 1.413T19 22zm0-2h14V10H5zM5 8h14V6H5zm0 0V6z" />
    </svg>
  );

  const time = (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><g fill="none"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" /><path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0 2a1 1 0 0 1 .993.883L13 7v4.586l2.707 2.707a1 1 0 0 1-1.32 1.497l-.094-.083l-3-3a1 1 0 0 1-.284-.576L11 12V7a1 1 0 0 1 1-1" /></g></svg>
  );
  return (
    <Row>
      {selectedEvent.map((val, i) => {
        const wholesalerEvent =
          isWholesalerEvent?.(val.event_id);

        const isNormalEventSelected =
          ids?.some(
            (id) =>
              String(id) === String(val.event_id)
          );

        const isWholesalerEventSaved =
          savedIds?.some(
            (id) =>
              String(id) === String(val.event_id)
          );

        const shouldShowGreen =
          component &&
          val.is_default_event === "0" &&
          (
            wholesalerEvent
              ? isWholesalerEventSaved
              : isNormalEventSelected
          );

        return (
          <React.Fragment>
            <Col xs={12} sm={12} md={6} lg={6} xl={4} xxl={4} key={i}>
              <div
                className="container container-content"
                style={{
                  borderColor: shouldShowGreen
                    ? "#4BB543"
                    : undefined,

                  borderWidth: 2,
                }}
                disabled={val.is_default_event === "1"}
                onClick={() =>
                  component &&
                  val.is_default_event === "0" &&
                  handleEvents(val.event_id)
                }
              >
                <h6 className="mb-3">
                  {Calendar}{" "}
                  {val.event_date}
                </h6>
                <h4>
                  <span>{val.event_name}</span>
                </h4>

                <p title={val.short_description} className="event-desc">
                  {val?.short_description}
                  <span
                    style={{
                      cursor: "pointer",
                      color: "green",
                      fontSize: "15px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowModal(true);
                      setViewMoreIndex(i);
                    }}
                  >
                    {/* {val?.short_description.length > 75 && "  ... View More"} */}
                  </span>
              </p>

                {val.wholesaler_list.length > 0 &&
                  val.allow_company_list === "1" && (
                    <h6 className="wholesaler">
                      Wholesaler Enabled{" "}
                      <svg
                        style={{ color: "#0d6efd" }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </h6>
                  )}
                <div className="event-date">
                  <span>
                    {time}{" "}
                    {val.event_start_time}
                  </span>{" "}
                  -
                  <span>
                    {" "}{time}{" "}
                    {val.event_end_time}
                  </span>
                </div>
                {val.is_enabled_for_guest_label === "Yes" && (
                  <h6 className="guest">
                    Guest Invited{" "}
                    {/* <svg style={{ color: "#0d6efd" }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                        </svg> */}
                  </h6>
                )}

                {val.allow_activity_event === "1" && (
                  <h6 className={`activity ${val.is_enabled_for_guest_label === "Yes" ? "both-events" : ""
                    }`}>
                    Activity Event
                  </h6>
                )}
              </div>
            </Col>
            <Modal
              show={showModal}
              onHide={handleClose}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header
                closeButton
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignContent: "center",
                }}
              >
                <Modal.Title id="contained-modal-title-vcenter">
                  <h6>
                    <svg
                      style={{ color: "#0d6efd" }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar-check-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708z" />
                    </svg>{" "}
                    {selectedEvent[viewMoreindex]?.event_date}
                  </h6>
                  {val.wholesaler_list.length > 0 && (
                    <h6 className="wholesaler">
                      Wholesaler Enabled{" "}
                      <svg
                        style={{ color: "#0d6efd" }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </h6>
                  )}

                  {val.is_enabled_for_guest_label === "Yes" && (
                    <h6 className="guest">
                      Guest{" "}
                      {/* <svg style={{ color: "#0d6efd" }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                        </svg> */}
                    </h6>
                  )}
                </Modal.Title>
                <Modal.Title>
                  <div className="event-date">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-clock-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                      </svg>{" "}
                      {selectedEvent[viewMoreindex]?.event_start_time}
                    </span>{" "}
                    -
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-clock-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                      </svg>{" "}
                      {selectedEvent[viewMoreindex]?.event_end_time}
                    </span>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h4>{selectedEvent[viewMoreindex]?.event_name}</h4>
                <p>{selectedEvent[viewMoreindex]?.short_description}</p>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={handleClose} variant="danger">
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </React.Fragment>
        );
      })}
    </Row>
  );
};

export default GenericEventDates;